import { Controller } from "@hotwired/stimulus";
import { setupTooltips } from "../../../bootstrap";

// RentVerification Lease Duration Form controller
export default class extends Controller {

  connect() {
    setupTooltips()
  }
}
